$(function() {
    /*
    $('.no-touch .overview__thumb').hoverIntent({
        over : function(){
            $('.overview__thumb__info.active').removeClass('active');
            $(this).find('.overview__thumb__info').addClass('active');
        },
        interval: 30,
        timeout: 500,
        out : function(){

        }
    });

    $('.overview__thumb__close').on('click', function(){
        $(this).closest('.overview__thumb__info').removeClass('active');
    });
    */
    

});
